import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import GuideArticlePage from "../pages/guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-beginners-guide",
    element: <ArticlePage />,
  },
  {
    path: "/guide/:slug",
    element: <GuideArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;